import { render } from "./ServiceCategories.vue?vue&type=template&id=89e3041e&scoped=true"
import script from "./ServiceCategories.vue?vue&type=script&lang=js"
export * from "./ServiceCategories.vue?vue&type=script&lang=js"

import "./ServiceCategories.vue?vue&type=style&index=0&id=89e3041e&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e3041e"]])

export default __exports__